// extracted by mini-css-extract-plugin
export default {"root":"ChapterHeaderExtra_root__hqeCr"};